import { render } from "./TalkToMyData.vue?vue&type=template&id=327a19a9&scoped=true"
import script from "./TalkToMyData.vue?vue&type=script&lang=js"
export * from "./TalkToMyData.vue?vue&type=script&lang=js"

import "./TalkToMyData.vue?vue&type=style&index=0&id=327a19a9&scoped=true&lang=css"
import "./TalkToMyData.vue?vue&type=style&index=1&id=327a19a9&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327a19a9"]])

export default __exports__